import { render, staticRenderFns } from "./SendClientMail.vue?vue&type=template&id=84a77532&"
import script from "./SendClientMail.vue?vue&type=script&lang=js&"
export * from "./SendClientMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports